import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldSetTag',
  props: {
		styleField: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: "Title Legend",
		},
		styleLegend: {
			type: String,
			default: "",
		},
		link: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass([__props.styleField, { ' w-full p-6 ': true }])
  }, [
    _createElementVNode("legend", {
      class: _normalizeClass([__props.styleLegend, { 'px-2 py-1 text-sm': true }])
    }, _toDisplayString(__props.title), 3),
    (__props.link != '')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: { name: __props.link }
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["to"]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 2))
}
}

})